var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":_vm.isShow,"color":"warning","outline":""}},[_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('useXRobotmonForSpeed'))+"\n  ")]),(_vm.supportGame === 'tsum')?_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('tsumHighPriceTip'))+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }